<script setup>
const filters = ref({
    A: false,
    B: false,
    C: false,
    D: false,
    E: false,
    F: false,
    G: false,
    H: false,
    I: false,
    J: false,
    K: false,
    L: false,
    M: false,
    N: false,
    O: false,
    P: false,
    Q: false,
    R: false,
    S: false,
    T: false,
    U: false,
    V: false,
    W: false,
    X: false,
    Y: false,
    Z: false,
});

const emits = defineEmits(['updateSelection']);

const toggleFilter = (filter) => {
    if (filter) {
        filters.value[filter] = !filters.value[filter];
    }
    const selections = [];
    for (const key in filters.value) {
        if (filters.value[key]) {
            selections.push(key);
        }
    }
    emits('updateSelection', selections);
};
</script>

<template>
    <div class="letter-filter mx-auto mb-16 max-w-full overflow-x-scroll">
        <div class="flex justify-between gap-2">
            <div
                v-for="(key, val) in filters"
                :key="key"
                class="letter"
                :class="filters[val] ? 'active' : ''"
                @click="toggleFilter(val)"
            >
                {{ val }}
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.letter-filter {
    .letter {
        width: 35px;
        height: 35px;
        border: 1px solid #dedede;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        line-height: 18px;
        cursor: pointer;
        min-width: 35px;
        &.active {
            border-color: #1c1c1c;
            background-color: #1c1c1c;
            color: $white;
        }
    }
}
</style>
